import { TDifficulty } from "./types"

export const difficulties: TDifficulty[] = [
    {title: 'Easy'},
    {title: 'Medium'},
    {title: 'Hard'},
    {title: 'Expert'},
    {title: 'Evil'},
]